import dayjs from "dayjs";

export const formatDateRange = (
	dateFrom?: Date | null,
	dateTo?: Date | null,
): string => {
	const format = (date: Date) => dayjs(date).format("DD.MM.YYYY");

	if (dateFrom && dateTo) return `${format(dateFrom)} - ${format(dateTo)}`;
	if (dateFrom) return format(dateFrom);
	if (dateTo) return format(dateTo);

	return "";
};
